import React from 'react';
import { TableProps } from './Table.types';
import { TableHeaderColumn } from './TableHeaderColumn';
import { twMerge } from '@shared/utils/twMerge';

export const TableHeader = <T,>({
  columns,
  onSort,
  styles,
  sortState,
  darkMode,
}: Pick<TableProps<T>, 'columns' | 'onSort' | 'sortState' | 'styles' | 'darkMode'>) => {
  return (
    <thead className={twMerge('thead relative z-[2]', styles?.thead)}>
      <tr className={twMerge('tr', styles?.headerTr)}>
        {columns.map((column, index) => {
          const isFirstColumn = index === 0;
          const isLastColumn = index === columns.length - 1;

          return (
            <TableHeaderColumn
              key={index}
              styles={styles}
              darkMode={darkMode}
              column={column}
              index={index}
              onSort={onSort}
              sortState={sortState}
              isFirstColumn={isFirstColumn}
              isLastColumn={isLastColumn}
            />
          );
        })}
      </tr>
    </thead>
  );
};
